// extracted by mini-css-extract-plugin
export default {"paddingRight":"FilterFailedRow-paddingRight_WzEZa"};